import { LocalStorageAdapter } from "@/infrastructure/adapters/localStorage/LocalStorage.adapter";
import { JsonSerializer } from "@/infrastructure/serializers/JsonSerializer";

const STORAGE_KEY = "sidebar-collapsed";

class SidebarStateRepository {
  private readonly storage = new LocalStorageAdapter(new JsonSerializer());

  async getCollapsed(): Promise<boolean> {
    const item = await this.storage.retrieve<boolean>(STORAGE_KEY);
    return item?.value ?? false;
  }

  async setCollapsed(collapsed: boolean): Promise<void> {
    await this.storage.store({ key: STORAGE_KEY, value: collapsed });
  }
}

export const sidebarStateRepository = new SidebarStateRepository();
